import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/site";
import PopStatus from "./PopStatus";

const LINKS = [
  { id: "paket", label: "Paket Internet" },
  { id: "keunggulan", label: "Keunggulan" },
  { id: "jangkauan", label: "Cek Jangkauan" },
  { id: "pasang", label: "Ajukan Pasang" },
];

const PORTAL_URL = "https://billing.fasnetfiber.com/portal";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 450);
    } else {
      scrollToId(id);
    }
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color] duration-300 ${
        scrolled || location.pathname !== "/"
          ? "border-white/10 bg-[#050914]/85 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-5 lg:px-8">
        <button data-testid="nav-logo" onClick={() => go("beranda")} className="flex items-center">
          <img src="/images/logo-navbar.png" alt="Fasnet Fiber" className="h-9 w-auto sm:h-11" />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-link-bayar"
            onClick={() => window.open(PORTAL_URL, "_blank", "noopener")}
            className="text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-white"
          >
            Bayar Tagihan
          </button>
          <button
            data-testid="nav-link-mitra"
            onClick={() => navigate("/mitra")}
            className="nav-mitra text-sm"
          >
            Jadi Mitra Fasnet
          </button>
        </nav>
        <div className="flex items-center gap-3">
          <PopStatus />
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="p-2 text-white lg:hidden"
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="border-t border-white/10 bg-[#050914]/95 px-5 py-4 backdrop-blur-xl lg:hidden"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full border-b border-white/5 py-3 text-left text-base text-slate-200"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-link-bayar"
            onClick={() => {
              setOpen(false);
              window.open(PORTAL_URL, "_blank", "noopener");
            }}
            className="block w-full border-b border-white/5 py-3 text-left text-base text-slate-200"
          >
            Bayar Tagihan
          </button>
          <button
            data-testid="nav-mobile-link-mitra"
            onClick={() => {
              setOpen(false);
              navigate("/mitra");
            }}
            className="nav-mitra block w-full border-b border-white/5 py-3 text-left text-base"
          >
            Jadi Mitra Fasnet
          </button>
        </div>
      )}
    </header>
  );
}
